import { useState } from "react";

import useStore from "../../../hooks/store/useStore";

export default function useStoryVideo() {
  const [showVideo, setShowVideo] = useState(false);
  const { userInformation } = useStore((state) => state.user);
  const { market } = userInformation || {};

  const videoUrl =
    market === "HK"
      ? `https://service.worldfamilyenglish.com/${process.env.REACT_APP_BLOB_FOLDER}/data/trial-mode/online-experience/videos/Story.mp4`
      : "https://player.vimeo.com/video/1031468559?title=0&byline=0&portrait=0";

  return { showVideo, setShowVideo, videoUrl };
}
